import type {RegistrationSelectItem} from 'modules/VendorRegister/types';
import type {Control, FieldValues, Path} from 'react-hook-form';

import {Select} from '@ds/components';
import {Controller} from 'react-hook-form';

type SelectFieldProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  label: string;
  items: RegistrationSelectItem[];
  placeholder: string;
  required?: boolean;
};

const SelectField = (<TFieldValues extends FieldValues>({
  name,
  control,
  label,
  items,
  placeholder,
  required
}: SelectFieldProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <div className="flex flex-col gap-1.5">
          <label htmlFor={String(name)} className="text-body-sm-emphasis text-gray-08">
            {label}
            {required ? <span className="text-destructive">*</span> : null}
          </label>
          <Select
            id={String(name)}
            className="[&>button]:h-12"
            value={field.value ?? ''}
            options={items}
            placeholder={placeholder}
            onChange={field.onChange}
          />
          {error?.message ? (
            <span className="px-2 text-field-caption text-destructive">{error.message}</span>
          ) : null}
        </div>
      )}
    />
  );
}) satisfies React.FC<SelectFieldProps<FieldValues>>;

export default SelectField;
